import * as Sebrae from '@sebrae/react-core';
import * as React from 'react';
import { CycleComboModel } from '../models/cycle-model';

interface CycleHookProps {
  fetchCycleComboLoading: boolean;
  fetchCycleComboError?: Sebrae.HttpErrorModel;
  fetchCycleCombo(): Promise<CycleComboModel[]>;
}

export function useCycleComboService(): CycleHookProps {
  const { backendGet } = Sebrae.useBackend();

  const [fetchCycleComboLoading, setFetchCycleComboLoading] =
    React.useState(false);
  const [fetchCycleComboError, setCycleComboError] =
    React.useState<Sebrae.HttpErrorModel>();
  const fetchCycleCombo = React.useCallback(() => {
    setFetchCycleComboLoading(true);
    setCycleComboError(undefined);

    const request = backendGet<CycleComboModel[]>(`/ciclos/combo`);

    request
      .catch(setCycleComboError)
      .finally(() => setFetchCycleComboLoading(false));

    return request;
  }, [backendGet]);

  return {
    fetchCycleComboLoading,
    fetchCycleComboError,
    fetchCycleCombo,
  };
}
